import request from 'utils/request';
import { baseUrl, baseUrlLottery } from 'config/env';
import HiCache from 'utils/cache';
import HiStance from 'utils/HiStance';
import axios from 'axios';
import { useWsSportStore } from 'store/modules/wsSportStore';
import { WsSportHandicap } from 'types/wsSportType';

export default function send(options: any = {}): Promise<any> {
    if (!options.params) options.params = {};
    if (!options.data) options.data = {};

    // 处理 http
    if (options.url.indexOf('http') !== 0) {
        const ignoreUrl = ['/oauth2/list', '/oauth2/authUrl', '/oauth2/login'];
        // 如果路径包含 ignoreUrl 则不拼接 baseUrl
        if (!ignoreUrl.some(url => options.url.startsWith(url))) {
            options.url = baseUrl() + options.url;
        }
    }

    options.headers = {
        [HiStance.DEVICE]: 'H5',
        // [HiStance.GAME]: '3',
        // [HiStance.HANDICAP]: HiCache.getCache(HiStance.HANDICAP) || HiStance.HANDICAP_DEFAULT_VALUE,
    };
    // console.log(options.url, '---------请求全路径');
    return request(options);
}

export function sendWsLottery(options: any = {}, cancelExecutor?: (cancel: () => void) => void): Promise<any> {
    if (!options.params) options.params = {};
    if (!options.data) options.data = {};

    const wsSportStore = useWsSportStore();

    // 创建CancelToken
    let cancel;
    options.cancelToken = new axios.CancelToken(function executor(c) {
        cancel = c;
        // 如果提供了cancelExecutor，则调用它
        if (cancelExecutor) {
            cancelExecutor(cancel);
        }
    });

    // 处理 http
    if (options.url.indexOf('http') !== 0) {
        options.url = baseUrl() + options.url;
    }

    options.headers = {
        [HiStance.DEVICE]: 'H5',
        [HiStance.GAME]: '2',
        // [HiStance.HANDICAP]: HiCache.getCache(HiStance.HANDICAP) || HiStance.HANDICAP_DEFAULT_VALUE,
        [HiStance.HANDICAP]: wsSportStore.sportHandicap === WsSportHandicap.Europe ? 'E' : 'H',
    };
    // console.log(options.url, '---------请求全路径');
    return request(options);
}

export function sendLottery(options: any = {}): Promise<any> {
    if (!options.params) options.params = {};
    if (!options.data) options.data = {};

    // 处理 http
    if (options.url.indexOf('http') !== 0) {
        options.url = baseUrlLottery() + options.url;
    }

    options.headers = {
        [HiStance.DEVICE]: 'H5',
        [HiStance.GAME]: '3',
        [HiStance.HANDICAP]: HiCache.getCache(HiStance.HANDICAP) || HiStance.HANDICAP_DEFAULT_VALUE,
    };

    // console.log(options.url, '---------请求全路径');
    return request(options);
}
